import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import { ApiClient } from "@/utilities/ApiClient";
    import { Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Utils } from "@/utilities/Utils";


    @Component({
        components: {
            ApiButton
        }
    })

    export default class DeleteBookingModal extends Vue {

        private checkboxStatus: string = "false"
        private booking = new BookingVM();
        private isDisabled: boolean = true;

        @Watch("checkboxStatus")
        onChanged(value: any) {
            if (this.checkboxStatus === "true") {
                this.isDisabled = false
            }
            if (this.checkboxStatus === "false") {
                this.isDisabled = true
            }
        }

        show(booking: BookingVM) {
            this.booking = booking;
            this.$bvModal.show("deleteBookingModal")
        }

        cancel() {
            this.$bvModal.hide("deleteBookingModal")
        }

        async deleteBooking() {
            await ApiClient.post("/Api/Booking/DeleteBooking", this.booking.id, event);
            toastr.warning("Deleted");
            await this.$emit("refreshSearch");
            Utils.resetObject(this.booking);
            this.$bvModal.hide("deleteBookingModal")
            this.$bvModal.hide("bookingModal");
        }

    }